import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {

	/**
	 * 节目单列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	programList( params={} ) {
		return request({
	    url: baseUrl + '/screen/programList',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 节目单修改
	**/
	programEdit(id,data){
		return request({
			url: baseUrl + '/screen/programList/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 节目单删除
	**/
	programDel(id){
		return request({
			url: baseUrl + '/screen/programList/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 节目单添加
	**/
	programAdd(data){
		return request({
			url: baseUrl + '/screen/programList',
			method:'POST',
			data
		})
	},

	/**
	 * 屏幕分配
	**/
	programFen(data){
		return request({
			url: baseUrl + '/screen/programFen',
			method:'POST',
			data
		})
	},

	/**
	 * 屏幕控制
	 * ID：节目单ID 
	**/
	// programNowSend(data){
	// 	return request({
	// 		url: '/v1/screen/projectionScreen',
	// 		method:'POST',
	// 		data
	// 	})
	// }

	/**
	 * 立即投屏
	**/
	programNowSend(id){
		return request({
			url: baseUrl + '/screen/sendScreenCommands/'+id,
			method:'POST'
		})
	}

}